export function AboutUs() {
  return (
    <section id="about" className="about">
      <h2>About</h2>
      <div className="about-content">
        <p>
          Comprised of Ben Nelson (Bass/Vocals), Seb Joubert (Guitar/Vocals),
          and Blake Stewart (Drums), Cascade is a hard hitting three piece
          Pop/Punk band based in Vancouver, Canada. Cascade's music is a
          powerful and emotional trip with heavy guitars, loud drums and
          meaningful lyrics. They released their first two singles titled
          "Greenwater" and "Cheap Fun" in February of 2025 in anticipation of
          their debut album, "New Distraction" that was released in March of the
          same year. With the success of "Cheap Fun", Cascade gained the
          traction to assist with the drop of their debut album, all of which
          was produced by their very own Ben Nelson. With influences from "The
          Story So Far" to "Title Fight" to "Vulfpeck", Cascade's sound is a
          unique mix of musical elements. Blake Stewart’s funk influence along
          with Ben and Seb's punk and hardcore playing style makes for some
          heavy, intricate breakdowns in their tracks. Cascade is constantly in
          the studio writing new music and playing electrifying shows across BC.
          Fans can expect even more intense and explosive music as Cascade works
          on redefining their genre. With their eyes on the future and big plans
          ahead, Cascade is just getting started, getting ready to bring their
          sound to the world.
        </p>
        <div className="about-images">
          <img src="/images/polaroid.png" alt="Band " />
        </div>
      </div>
    </section>
  );
}
